export const GET_TOTAL_ATTRIBUTES_DATA = '[ATTRIBUTES] GET_TOTAL_ATTRIBUTES_DATA';

export const GET_SUB_ATTRIBUTES = '[ATTRIBUTES] GET_SUB_ATTRIBUTES';

export const GET_ATTRIBUTE_BY_ID = '[ATTRIBUTES] GET_ATTRIBUTE_BY_ID';
